import SearchTicket from 'modules/search-ticket';

export default SearchTicket;
